import React from 'react';
// react bootstrap
import Image from 'react-bootstrap/Image';
// image
import ReadingImage from '../../../images/reading_img.png';
// styles
import { Wrapper } from './LoginPageImage.styles';

function LoginPageImage() {
  return (
    <Wrapper>
      <div className={'text-center'}>
        <Image src={ReadingImage} fluid />
        <h1 className='text'>
          Too many <span style={{ color: 'var(--brandSecondary)' }}>books</span>
          ,
        </h1>
        <h1 style={{ color: 'var(--black)' }} className='text'>
          Too little{' '}
          <span style={{ color: 'var(--brandSecondary)' }}>time</span>.
        </h1>
      </div>
    </Wrapper>
  );
}

export default LoginPageImage;
